<template>
    <div class="relative">
        <!-- Badge novo -->
        <div v-if="row.new" class="absolute -top-1 -right-1 z-10">
            <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-emerald-500 text-white">
                Novo
            </span>
        </div>

        <!-- Indicador de inativo -->
        <div v-if="status" class="absolute top-2 left-2 z-10">
            <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-red-50 text-red-600">
                <XCircleIcon class="w-3.5 h-3.5"/>
                <span class="text-[10px] font-medium">Inativo</span>
            </span>
        </div>

        <div class="p-4 w-full flex items-center gap-3 text-left">
            <!-- Avatar -->
            <div class="flex-shrink-0">
                <Avatar :avatar="row.avatar" size="lg" />
            </div>

            <!-- Info -->
            <div class="min-w-0 flex-1">
                <p class="text-sm font-medium text-gray-900 truncate">{{ row.name }}</p>
                <p class="text-xs text-gray-500 truncate mt-0.5">{{ row.email }}</p>

                <!-- Role badge -->
                <div v-if="row.roles && row.roles.name" class="mt-2 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-gray-100 text-xs text-gray-600">
                    <span class="w-1.5 h-1.5 rounded-full" :class="row.roles.color || 'bg-gray-400'"></span>
                    {{ row.roles.name }}
                </div>
                <div v-else class="mt-2 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-red-50 text-xs text-red-600 font-medium">
                    <span class="w-1.5 h-1.5 rounded-full bg-red-500"></span>
                    Sem nível de acesso
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {  XCircleIcon } from '@heroicons/vue/24/solid'

export default {

    name:"UserCardSmall",
    props: {
        row: {
            type: Object,
            required: true
        },
        status: {
            type: Boolean,
            default: false
        },
    },
    methods: {

       
    },
    components: {        
        XCircleIcon,
    },
}
</script>